module.exports = __webpack_public_path__ + "static/media/lunaDesktop.09ccf7ca.svg";